exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#eConsent .content{line-height:1.35em}#eConsent .agree{position:relative}#eConsent label{line-height:1.2em}#eConsent .validated input[type=checkbox].ng-invalid+.errorTooltipRuleSpecific{width:300px;font-size:12px;top:30px;left:0;line-height:1.2em;width:275px}#eConsent .buttons{margin-top:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader!./pages/xo-eConsent/styles.less
// module id = ../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./pages/xo-eConsent/styles.less
// module chunks = 1